import styled, { css } from 'styled-components';

export const InvoiceInfoWrapper = styled.div`
  ${({ theme }) => css`
    align-items: end;
    display: flex;
    flex-wrap: wrap;
    font-family: ${theme.v2.font.family.primary};
    gap: 24px;
  `};
`;

export const InvoiceInfo = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    flex-direction: column;
    font-size: ${theme.v2.font.sizes.xs};
  `}
`;

export const InvoiceInfoTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;
